// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Site from './Site';
import router from './router';

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
	el: '#site',
	router,
	components: { Site },
	template: '<Site/>'
});


// WEBPACK FOOTER //
// ./src/main.js